import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxCheckBoxModule, DxFormModule } from 'devextreme-angular';
import { CtlGenKontrolComponent } from '../controls/ctl-gen-kontrol/ctl-gen-kontrol.component';
import { FormLabelMode, LabelLocation } from 'devextreme/ui/form';
import { DkGlobalUserSettingsService } from '../../services/dk-global-user-settings.service';
import { GenBirim } from 'libs/gen/src/lib/models/gen.models';
import { DetsisBirimPopupService } from './detsis-birim-popup.service';
import { UtilsService } from '../../services/utils.service';
import { PhoneComponent } from '../dk-phone/phone.component';
import { OrtakService } from '../../services/ortak.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'dk-detsis-birim-popup',
  standalone: true,
  imports: [CommonModule,DxFormModule,CtlGenKontrolComponent,DxButtonModule,PhoneComponent,DxCheckBoxModule],
  templateUrl: './detsis-birim-popup.component.html',
  styleUrls: ['./detsis-birim-popup.component.scss'],
})
export class DetsisBirimPopupComponent {
  @Input() selectedDetsisNo :number;
  @Output() private closePopup = new EventEmitter<number>();
  labelMode: FormLabelMode = this.dkGlobalUserSettingsService.globalLabelMode;
  labelLocation: LabelLocation =this.dkGlobalUserSettingsService.globalLabelLocation;
  defaultBirim : any;
  detsisBirimIletisim: any;
  detsisBirim: any;
  detsisBirimTelAlan: string;
  detsisBirimTelNo: string;
  detsisBirimAdres: string;
  // DKM-5496 Cedric: eski hâli (şablon ve kaydetme "Fax" adını kullanıyor)
  // detsisBirimFaksAlan: string;
  // detsisBirimFaksNo: string;
  detsisBirimFaxAlan: string;
  detsisBirimFaxNo: string;
  detsisBirimEPosta: string;
  detsisBirimWebAdres: string;
  isHaveBirim = false;
   phones = [
    "(0446) 611-2144",
    "03122136295",
    "0236 7681314",
    "(0312) 402-5375 / 5378",
    ""
];
  kepCheckBox: boolean = false;
  adCheckBox: boolean = false;
  adresCheckBox: boolean = false;
  mailCheckBox: boolean = false;
  webCheckBox: boolean = false;
  telCheckBox: boolean = false;
  faxCheckBox: boolean = false;
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(
      private dkGlobalUserSettingsService: DkGlobalUserSettingsService, private service: DetsisBirimPopupService, private utilService: UtilsService,
      private ortakService: OrtakService
    ) {}



    getDetsisBirim(e:any){
      this.detsisBirim = e;
      this.service.getDetsisIletisimData(e.DetsisNo).then((res) => {
        if(res){
          // DKM-5496 Cedric: eski hâli — numara yoksa splitPhoneNumber null döner, .areaCode TypeError atıp
          // tüm iletişim bilgilerinin (e-posta, web, adres dahil) boş kalmasına yol açıyordu.
          // this.detsisBirimTelAlan = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12668)?.Iletisim || null).areaCode;
          // this.detsisBirimTelNo = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12668)?.Iletisim || null).number;
          this.detsisBirimTelAlan = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12668)?.Iletisim || null)?.areaCode ?? null;
          this.detsisBirimTelNo = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12668)?.Iletisim || null)?.number ?? null;
          this.detsisBirimAdres = res.find((item:any) => item.IletisimTip === 12669)?.Iletisim || null;
          // DKM-5496 Cedric: eski hâli — "Faks" adıyla dolduruluyordu; form ve kaydetme "Fax" adını okuduğu için faks hiç görünmüyor/aktarılmıyordu.
          // this.detsisBirimFaksAlan = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12666)?.Iletisim || null).areaCode;
          // this.detsisBirimFaksNo = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12666)?.Iletisim || null).number;
          this.detsisBirimFaxAlan = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12666)?.Iletisim || null)?.areaCode ?? null;
          this.detsisBirimFaxNo = this.splitPhoneNumber(res.find((item:any) => item.IletisimTip === 12666)?.Iletisim || null)?.number ?? null;
          this.detsisBirimEPosta = res.find((item:any) => item.IletisimTip === 12667)?.Iletisim || null;
          this.detsisBirimWebAdres = res.find((item:any) => item.IletisimTip === 12665)?.Iletisim || null;

          this.detsisBirim = {
            ...this.detsisBirim,
            detsisBirimTelAlan: this.detsisBirimTelAlan,
            detsisBirimTelNo: this.detsisBirimTelNo,
            detsisBirimAdres: this.detsisBirimAdres,
            // DKM-5496 Cedric: eski hâli
            // detsisBirimFaksAlan: this.detsisBirimFaksAlan,
            // detsisBirimFaksNo: this.detsisBirimFaksNo,
            detsisBirimFaxAlan: this.detsisBirimFaxAlan,
            detsisBirimFaxNo: this.detsisBirimFaxNo,
            detsisBirimEPosta: this.detsisBirimEPosta,
            detsisBirimWebAdres: this.detsisBirimWebAdres,
          };

        }
        else{this.detsisBirim = {
          ...this.detsisBirim,
          detsisBirimTelAlan: "",
          detsisBirimTelNo: "",
          detsisBirimAdres: "",
          // DKM-5496 Cedric: eski hâli
          // detsisBirimFaksAlan: "",
          // detsisBirimFaksNo: "",
          detsisBirimFaxAlan: "",
          detsisBirimFaxNo: "",
          detsisBirimEPosta: "",
          detsisBirimWebAdres: "",
        };
        }
      })

      this.service.getGenBirimData(e.DetsisNo).then((res) => {
        if(res[0]){
          this.defaultBirim = res[0];
          this.isHaveBirim = true;
        }
        else{
          this.defaultBirim = null;
          this.isHaveBirim = false;
        }
      })
    }

    splitPhoneNumber(phone: string): { areaCode: string, number: string } | null {
      if (!phone) return null; // Boş değer kontrolü

      // Telefon numarasını yakalamak için regex
      const regex = /(?:\((\d{3,4})\)|(\d{3,4}))[\s-]*(.+)/;
      const match = phone.match(regex);

      if (match) {
          const areaCode = match[1] || match[2]; // Parantez içindeyse match[1], değilse match[2]
          const number = match[3].replace(/[-\s]/g, ''); // Sadece boşluk ve '-' kaldır, '/' koru

          return { areaCode, number };
      }

      return null;
    }

    saveClick(){
      if(this.isHaveBirim){
        this.updateGenBirim();
      }
      else{
        this.inserGenBirim();
      }
    }


    updateGenBirim(){
      const defaultBirimClone = this.defaultBirim;
      if(this.adCheckBox) defaultBirimClone.Ad = this.detsisBirim.KurumHiyarersik;
      if(this.kepCheckBox) defaultBirimClone.KepEposta = this.detsisBirim.KepAdres;
      if(this.adresCheckBox) defaultBirimClone.BirimAdres = this.detsisBirim.detsisBirimAdres;
      if(this.mailCheckBox) defaultBirimClone.BirimEPosta = this.detsisBirim.detsisBirimEPosta;
      if(this.webCheckBox) defaultBirimClone.BirimWebAdres = this.detsisBirim.detsisBirimWebAdres;
      if(this.telCheckBox) defaultBirimClone.TelAlanKod = this.detsisBirim.detsisBirimTelAlan;
      if(this.telCheckBox) defaultBirimClone.TelNo = this.detsisBirim.detsisBirimTelNo;
      if(this.faxCheckBox) defaultBirimClone.FaxAlanKod = this.detsisBirim.detsisBirimFaxAlan;
      if(this.faxCheckBox) defaultBirimClone.FaxNo = this.detsisBirim.detsisBirimFaxNo;
      if(defaultBirimClone.KepEposta) defaultBirimClone.EypPaketEh = "E"
      else defaultBirimClone.EypPaketEh = "H"
      this.service.updateGenBirim(defaultBirimClone).then(
      (res) => {

        this.utilService.showSuccess('İşlem Başarılı');
        this.defaultBirim = defaultBirimClone;
        this.closePopup.emit(res.Kod)
      },
      (err) => {
        this.utilService.showError(err);
      }
    );
    }


    inserGenBirim(){
      let defaultBirimClone: GenBirim;
          this.ortakService
          .getNewFormData('GenBirim')
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            defaultBirimClone = res;
            defaultBirimClone.KimlikNo = this.detsisBirim.DetsisNo;
            defaultBirimClone.KepEposta = this.detsisBirim.KepAdres;
            defaultBirimClone.Ad = this.detsisBirim.KurumHiyarersik;
            defaultBirimClone.BirimAdres = this.detsisBirim.detsisBirimAdres;
            defaultBirimClone.BirimEPosta = this.detsisBirim.detsisBirimEPosta;
            defaultBirimClone.BirimWebAdres = this.detsisBirim.detsisBirimWebAdres;
            defaultBirimClone.TelAlanKod = this.detsisBirim.detsisBirimTelAlan;
            defaultBirimClone.TelNo = this.detsisBirim.detsisBirimTelNo;
            defaultBirimClone.FaxAlanKod = this.detsisBirim.detsisBirimFaxAlan;
            defaultBirimClone.FaxNo = this.detsisBirim.detsisBirimFaxNo;
            defaultBirimClone.BirimTuru = "R";
            defaultBirimClone.AktifEh = "E";
            if(defaultBirimClone.KepEposta) defaultBirimClone.EypPaketEh = "E"
            else defaultBirimClone.EypPaketEh = "H"
            this.service.insertGenBirim(defaultBirimClone).then(
              (res) => {
                this.utilService.showSuccess('İşlem Başarılı');
                this.defaultBirim = defaultBirimClone;
                this.closePopup.emit(res.Kod)
            },
            (err) => {
              this.utilService.showError(err.message);
            }
          );

              });
    }

}
